import { render, staticRenderFns } from "./GameScreenField.vue?vue&type=template&id=822d7f90&scoped=true&"
import script from "./GameScreenField.vue?vue&type=script&lang=js&"
export * from "./GameScreenField.vue?vue&type=script&lang=js&"
import style0 from "./GameScreenField.vue?vue&type=style&index=0&id=822d7f90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822d7f90",
  null
  
)

export default component.exports